import { assert } from 'superstruct';
import httpClient from '../../shares/api/httpClient';
import { errorResponse } from '../../shares/ui/errorUI';
import { getGameListUrl } from '../gameLauncherUrl';
import { LogiSDKConfig } from '../../shares/model/config';
import { GameListConfig, SwipeGamesListSchema } from '../../shares/model/swipe';

const applyDefaults = (source: any) => ({
  gameData: source.gameId,
  placeHolderDom: `<div style="width: 100%;"><img src="${source.minigameImgUrl ?? 'https://cdn-asset.logifuture.com/casino/fallback/games/screenshots/Game_card.png'}" alt="Placeholder-Img" style="width: inherit;"></div>`,
});

const fetchMiniGameData = async (swipeSDKConfig: LogiSDKConfig) => {
  try {
    if (!swipeSDKConfig.miniGames?.gameListConfig) {
      throw new Error('Game list configuration is missing');
    }

    const tenantToken: string =
      (swipeSDKConfig.tenantId as string) ||
      (swipeSDKConfig.miniGames.gameListConfig.routeParams?.tenant as string) ||
      '';

    const localeParam = process.env.NX_DEFAULT_LOCALE || 'en-GB';

    const gameListUrl = getGameListUrl(
      swipeSDKConfig.miniGames.gameListConfig as GameListConfig,
      tenantToken,
      localeParam,
      'MINIGAME',
    );

    const apiResponse = await httpClient('GET', gameListUrl, {
      ...swipeSDKConfig.miniGames.gameListConfig.requestHeaders,
    });

    assert(apiResponse, SwipeGamesListSchema);

    return applyDefaults(apiResponse.games?.[0]);
  } catch (error) {
    console.error('Error fetching response from API:', error);
    return errorResponse();
  }
};

export default fetchMiniGameData;
